import React from "react";

/* Solid five-point star — membership marks. Inherits currentColor. */
export const StarIcon = ({ size = 10, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path d="M6 1.2l1.43 2.9 3.2.46-2.32 2.26.55 3.18L6 8.5l-2.86 1.5.55-3.18L1.37 4.56l3.2-.46L6 1.2z" />
  </svg>
);

/* The avatar overlay uses a slightly different star drawing to the pill's, so
   it is kept as its own export rather than scaled from the one above. */
export const StarIconSolid = ({ size = 10, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path d="M6 1l1.5 3.1 3.4.5-2.45 2.4.6 3.4L6 8.8 2.95 10.4l.6-3.4L1.1 4.6l3.4-.5z" />
  </svg>
);

export default StarIcon;
